export default __webpack_public_path__ + "static/BrandonGrotesque-Light-92ca8ddaa2010283ce2010bc9d17aee0.woff2";